module.exports = __webpack_public_path__ + "static/media/october2024-4.b92e36e5.webp";